<div fxLayout="column" class="faqs-container">
  <h4 class="faqs-title">
    {{ 'billing.faqSectionTitle' | translate }}
  </h4>
  <div class="faqs-wrap-container">
    <app-faqs-section [faqs]="faqs"></app-faqs-section>
  </div>
</div>
